import { render, staticRenderFns } from "./edit-prep.vue?vue&type=template&id=14997902&"
import script from "./edit-prep.vue?vue&type=script&lang=js&"
export * from "./edit-prep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports